import React, { useEffect, useState, useContext } from "react";
import httpService from "../../utility/httpService.js";
import { MainContext } from "context/MainContext.js";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";
import DynamicDetailsModal from "components/CustomerComponents/DynamicModal.js";
import { FaEye, FaPen, FaTrashAlt } from "react-icons/fa";
import DynamicTableComponentDateRange from "../../components/table/DynamicTableComponentDateRange.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import { getFormattedDateNDaysAgo } from "utility/Utility.js";
import { MdPrint } from "react-icons/md";

export default function TransactionSummary() {
  const {
    loading,
    backdrop,
    setBackdrop,
    setLoading,
    notifyError,
    notifySuccess,
  } = useContext(MainContext);
  const location = useLocation();

  const [cId, setCId] = useState(null);
  const [isModalOpenAccount, setIsModalOpenAccount] = useState(false);
  const [selectedCustomerAccount, setSelectedCustomerAccount] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [accountDetailList, setAccountDetailList] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [fileteredId, setFileteredId] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [accountDetailRequest, setAccountDetailRequest] = useState({
    organizationId: 0,
    startDate: null,
    endDate: null,
    filteredId: null,
    transactionType: "DEBIT",
    filteredBy: "all",
    page: 0,
    size: 0,
    sortBy: "createdDate",
    sortDir: "desc",
  });

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [startDate, endDate] = dateRange;

  const fetchOrgAccountDetails = async (fileteredId) => {
    try {
      setLoading(true);
      const organization =
        JSON.parse(localStorage.getItem("organization")) || null;
      if (organization) {
        accountDetailRequest.organizationId = organization.organizationId;

        if (!accountDetailRequest.startDate || !accountDetailRequest.endDate) {
          accountDetailRequest.startDate = getFormattedDateNDaysAgo(0);
          accountDetailRequest.endDate = getFormattedDateNDaysAgo(0);
        }

        accountDetailRequest.filteredBy = "all";
        if (fileteredId) {
          accountDetailRequest.filteredBy = "account";
          accountDetailRequest.filteredId = fileteredId;
        }

        accountDetailRequest.size = pageSize;
        accountDetailRequest.page = page;


        const response = await httpService.post(
          `/organizationAccount/getAccountDetailByDateRange`,
          accountDetailRequest,
        );

        setTotalElements(response.data?.totalElements);
        setTotalPages(response.data?.totalPages);
        setAccountDetailList(response.data?.content);
        setLoading(false);
      }
    } catch (err) {
      notifyError(err.message, err.data, 4000);
      setLoading(false);
    }
  };

  const handleDateRangeChange = (update) => {
    setDateRange(update);
    if (update[0] != null && update[1] != null) {
      let startingDate = update[0]?.toLocaleDateString().split("/");
      startingDate =
        startingDate[1] + "-" + startingDate[0] + "-" + startingDate[2];
      let endingDate = update[1]?.toLocaleDateString().split("/");
      endingDate = endingDate[1] + "-" + endingDate[0] + "-" + endingDate[2];
      setAccountDetailRequest({
        ...accountDetailRequest,
        startDate: startingDate,
        endDate: endingDate,
      });
    } else if (update[0] == null && update[1] == null) {
      setAccountDetailRequest({
        ...accountDetailRequest,
        startDate: null,
        endDate: null,
      });
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  useEffect(() => {
    fetchOrgAccountDetails(fileteredId);
  }, [fileteredId, accountDetailRequest, page, pageSize]);

  const fetchAccounts = async () => {
    try {
      const sidebarData =
        JSON.parse(localStorage.getItem("organization")) || null;
      if (sidebarData) {
        const response = await httpService.get(
          `/organizationAccount/getAccountByOrgId/${sidebarData.organizationId}`,
        );
        setAccounts(response.data || []);
      }
    } catch (err) {
      if (!cId) notifyError(err.message, err.data, 4000);
    }
  };

  const changeSelectedAccount = (account) => {
    setFileteredId(account);
  };

  const tableColumns = [
    { header: "Account", field: "accountName" },
    {
      header: "Type",
      field: "transactionType",
      render: (value) => {
        const baseClass = "font-semibold uppercase";
        if (value === "CREDIT")
          return (
            <span className="text-red-600">
              <i className="fas fa-arrow-up text-red-500 mr-1"></i>
              {value}
            </span>
          );
        if (value === "DEBIT")
          return (
            <span className="text-green-600">
              <i className="fas fa-arrow-down text-emerald-500 mr-1"></i>
              {value}
            </span>
          );
        else
          return (
            <span>
              <i className="fas fa-arrow-up text-emerald-500"></i>
              <i className="fas fa-arrow-down text-red-500  mr-1"></i>
              {value}
            </span>
          );
      },
    },
    { header: "Amount", field: "amount" },
    { header: "Comments", field: "comments" },
    { header: "Project", field: "projectName" },
    { header: "Customer", field: "customerName" },
    { header: "Unit", field: "unitSerialNo" },
    { header: "Created Date", field: "createdDate" },
  ];

  const handlePrint = async () => {
    setLoading(true);

    try {
      setLoading(true);
      const organization =
        JSON.parse(localStorage.getItem("organization")) || {};
      if (organization) {
        accountDetailRequest.organizationId = organization.organizationId;

        if (!accountDetailRequest.startDate || !accountDetailRequest.endDate) {
          accountDetailRequest.startDate = getFormattedDateNDaysAgo(0);
          accountDetailRequest.endDate = getFormattedDateNDaysAgo(0);
        }

        accountDetailRequest.filteredBy = "all";
        if (fileteredId) {
          accountDetailRequest.filteredBy = "account";
          accountDetailRequest.filteredId = fileteredId;
        }

        const response = await httpService.post(
          `/organizationAccount/getAccountDetailByDateRangePrint`,
          accountDetailRequest,
        );

        let totalDebitAmount = 0;
        let totalCreditAmount = 0;
        response?.data?.forEach((transaction) => {
          if (transaction.transactionType === "CREDIT") {
            totalCreditAmount += transaction.amount;
          }
          if (transaction.transactionType === "DEBIT") {
            totalDebitAmount += transaction.amount;
          }
        });

        response.organizationTitle = organization?.name;
        response.address = organization?.address;
        response.numbers = organization?.contactNo;
        response.totalDebitAmount = totalDebitAmount;
        response.totalCreditAmount = totalCreditAmount;

        const html = generateOrganizationLedgerHTML(response);

        const win = window.open("", "_blank");
        win.document.write(html);
        win.document.close();
        win.focus();
        setTimeout(() => win.print(), 500); // slight delay to render
        setLoading(false);
      }
    } catch (err) {
      notifyError(err.message, err.data, 4000);
      setLoading(false);
    }
  };

  const generateOrganizationLedgerHTML = (input) => {
    let data = input.data;
    let mainData = input?.data;
    const formattedDate = new Date().toLocaleString();

    return `
  <html>
    <head>
      <title>Organization Ledger</title>
      <style>
        body { font-family: Arial, sans-serif; font-size: 14px; margin: 20px; }
        .ledger-container { width: 800px; margin: auto; }
        .header { text-align: center; }
        .header h2 { margin: 0; font-size: 20px; }
        .header p { margin: 0; font-size: 12px; }
        .ledger-title { font-weight: bold; font-size: 16px; background: #000; color: #fff; padding: 5px; display: inline-block; margin: 10px 0; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid black; padding: 8px; text-align: left; font-size: 13px; }
        .footer { margin-top: 30px; border-top: 1px solid black; }
        .signature { text-align: right; margin-top: 50px; }
      </style>
    </head>
    <body>
      <div class="ledger-container">
        <div class="header">
          <h2>${input?.organizationTitle}</h2>
          <p>${input?.address}</p>
          <p>${input?.numbers}</p>
          <div class="ledger-title">ORGANIZATION ACCOUNT LEDGER</div>
        </div>

        <div>
          <p><strong>Total Debit ↓:</strong> ${parseFloat(
            input?.totalDebitAmount || 0,
          ).toLocaleString()}</p>
          <p><strong>Total Credit ↑:</strong> ${parseFloat(
            input?.totalCreditAmount || 0,
          ).toLocaleString()}</p>
          <p><strong>Ledger Date:</strong> ${formattedDate}</p>
        </div>

        <table>
          <thead>
            <tr>
              <th>Sr#</th>
              <th>Account Name</th>
              <th>Transaction Type</th>
              <th>Amount</th>
              <th>Narration</th>
              <th>Date</th>
              <th>Created By</th>
            </tr>
          </thead>
          <tbody>
            ${data
              .map((detail, ind) => {
                return `
                  <tr>
                    <td>${ind + 1}</td>
                    <td>${detail?.accountName}</td>
                    <td>${
                      detail.transactionType == "CREDIT"
                        ? "↑ CREDIT"
                        : "↓ DEBIT" || ""
                    }</td>
                    <td>${parseFloat(detail.amount || 0).toLocaleString()}</td>
                    <td>${detail.comments || "-"}</td>
                    <td>${
                      detail.createdDate ? detail.createdDate.split("T")[0] : ""
                    }</td>
                    <td>${detail.createdBy || "-"}</td>
                  </tr>
                `;
              })
              .join("")}
          </tbody>
        </table>

        <div class="footer">
          <p><strong>Print Date:</strong> ${formattedDate}</p>
        </div>
      </div>
    </body>
  </html>
  `;
  };

  const toggleModalAccount = () => {
    setBackdrop(!backdrop);
    setIsModalOpenAccount(!isModalOpenAccount);
  };

  const handleDetailModal = (data) => {
    const formattedAccountInfo = {
      "Transaction Info": {
        "Account Name": data?.accountName,
        "Transaction Type": data?.transactionType,
        Amount: data?.amount,
        Comments: data?.comments,
        "Project Name": data?.projectName,
        "Customer Name": data?.customerName,
        "Unit Serial No": data?.unitSerialNo,
      },
      "Audit Info": {
        "Created By": data?.createdBy,
        "Updated By": data?.updatedBy,
        "Created Date": data?.createdDate,
        "Updated Date": data?.updatedDate,
      },
    };

    setSelectedCustomerAccount(formattedAccountInfo);
    toggleModalAccount();
  };

  const TRANSACTION_TYPES = [
    { title: "CASH ACCOUNT", value: "DEBIT" },
    { title: "LIABILITY ACCOUNT", value: "CREDIT" },
  ];

  const onChangeType = (type) => {
    setAccountDetailRequest({ ...accountDetailRequest, transactionType: type });
  };
  const onClickSearch = (type) => {};

  return (
    <>
      <DynamicDetailsModal
        isOpen={isModalOpenAccount}
        onClose={toggleModalAccount}
        data={selectedCustomerAccount}
        title="Account Details"
      />
      <div className="container mx-auto p-4">
        <div className="w-full sm:mb-0">
          <div className="bg-white shadow-lg flex flex-wrap py-3 md:justify-content-between">
            <div className="  p-5 rounded-12 lg:w-4/12 md:w-6/12 sm:w-12/12">
              <label className="block text-sm font-medium mb-1 ">
                Select Account
              </label>
              <select
                value={fileteredId}
                onChange={(e) => changeSelectedAccount(e.target.value)}
                className="border rounded-lg px-3 py-2 w-full"
              >
                <option value="">All Accounts</option>
                {accounts.map((account) => (
                  <option key={account.id} value={account.id}>
                    {account.name} - {account.bankName}
                  </option>
                ))}
              </select>
            </div>
            <div className=" p-5 rounded-12 lg:w-4/12 md:w-6/12 sm:w-12/12">
              <label className="block text-sm font-medium mb-1 ">
                Select Type
              </label>
              <select
                value={accountDetailRequest.transactionType}
                onChange={(e) => onChangeType(e.target.value)}
                className="border rounded-lg px-3 py-2 w-full"
              >
                <option value="">All Types</option>
                {TRANSACTION_TYPES.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.title}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto p-4">
        <DynamicTableComponentDateRange
          fetchDataFunction={fetchOrgAccountDetails}
          setPage={setPage}
          page={page}
          setPageSize={setPageSize}
          data={accountDetailList}
          columns={tableColumns}
          pageSize={pageSize}
          totalPages={totalPages}
          totalElements={totalElements}
          loading={loading}
          title="Transaction Summary"
          actions={[
            {
              icon: FaEye,
              onClick: handleDetailModal,
              title: "View Details",
              className: "text-green-600",
            },
          ]}
          onChangeDate={handleDateRangeChange}
          startDate={startDate}
          endDate={endDate}
          changeTransactionType={null}
          selectTransactionType={null}
          firstButton={{
            icon: MdPrint,
            onClick: handlePrint,
            title: "Print Report",
            className: "bg-emerald-500",
          }}
        />
      </div>
    </>
  );
}
